import React, { FC } from 'react';
import styled from 'styled-components';
import ReplyIcon from '@mui/icons-material/Reply';

const StyledShortcutIcon = styled.div`
  border: 1px solid lightgrey;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  z-index: 2;

  position: absolute;
  left: -10px;
  top: -10px;

  svg {
    margin-bottom: 2px;
    font-size: 1.3rem !important;
  }

  &.list {
    top: 25px;
    left: -7px;
    width: 20px;
    height: 20px;

    svg {
      margin-bottom: 2px;
      font-size: 1rem !important;
    }
  }
`;

interface ShortcutIconProps {
  type?: 'list';
}

export const ShortcutIcon: FC<ShortcutIconProps> = ({ type }) => {
  return (
    <StyledShortcutIcon className={type}>
      <ReplyIcon />
    </StyledShortcutIcon>
  );
};
